import { Camera, Aperture, Focus, Film, Circle, ScanLine } from "lucide-react";

/**
 * Decorative camera & lens silhouettes scattered across the hero background.
 * Pure SVG via lucide icons. Pointer-events: none, never blocks interaction.
 */
export default function CameraBackdrop() {
  return (
    <div
      className="absolute inset-0 pointer-events-none overflow-hidden"
      aria-hidden="true"
      style={{ zIndex: 0 }}
      data-testid="camera-backdrop"
    >
      {/* Big aperture in top-right */}
      <Aperture
        className="absolute text-[#0A192F]"
        style={{ top: "-60px", right: "-80px", width: "380px", height: "380px", opacity: 0.05, strokeWidth: 0.8 }}
      />
      {/* Camera body in bottom-left */}
      <Camera
        className="absolute text-[#0A192F]"
        style={{ bottom: "20px", left: "-60px", width: "300px", height: "300px", opacity: 0.04, strokeWidth: 0.8 }}
      />
      {/* Focus reticle mid-left */}
      <Focus
        className="absolute text-[#2563EB]"
        style={{ top: "40%", left: "8%", width: "120px", height: "120px", opacity: 0.06, strokeWidth: 1 }}
      />
      {/* Film roll right */}
      <Film
        className="absolute text-[#0A192F]"
        style={{ top: "10%", right: "12%", width: "90px", height: "90px", opacity: 0.06, strokeWidth: 1, transform: "rotate(15deg)" }}
      />
      {/* Lens rings */}
      <Circle
        className="absolute text-[#F59E0B]"
        style={{ top: "55%", right: "20%", width: "160px", height: "160px", opacity: 0.06, strokeWidth: 0.6 }}
      />
      <Circle
        className="absolute text-[#0A192F]"
        style={{ top: "58%", right: "22%", width: "120px", height: "120px", opacity: 0.05, strokeWidth: 0.6 }}
      />
      {/* Scan line accent */}
      <ScanLine
        className="absolute text-[#0A192F]"
        style={{ bottom: "30%", right: "30%", width: "100px", height: "100px", opacity: 0.05, strokeWidth: 1 }}
      />
      {/* Tiny aperture floating */}
      <Aperture
        className="absolute text-[#2563EB]"
        style={{ top: "70%", left: "30%", width: "60px", height: "60px", opacity: 0.08, strokeWidth: 1.2 }}
      />
    </div>
  );
}
